import { ChangeEventHandler, Dispatch, SetStateAction, useEffect, useRef } from "react";
import { genLotUnits, getMobileAppSettings, onlyNum, saveLotUnits } from "../../../lib/funcs";
import InputGroup from "../InputGroup";
import { useLanguage } from "../../../lib/LanguageContext";
import { useDispatch } from "react-redux";

interface IUnitsOf1Lot {
  lotUnits: string | number;
  setLotUnits: Dispatch<SetStateAction<number | string>>;
  setTradeSizeInfo: Dispatch<SetStateAction<ITradeSizeInfo | undefined>>;
  selectedInstrument: IInstrument | undefined;
  className?: string;
  calc: ICalculators;
}

function UnitsOf1Lot({
  lotUnits,
  setLotUnits,
  setTradeSizeInfo,
  selectedInstrument,
  className,
  calc
}: IUnitsOf1Lot) {
  const { languageData } = useLanguage();

  const isFirstRender = useRef(true);
  const dispatch = useDispatch();

  const previous = useRef({ selectedInstrument });

  useEffect(() => {
    if(isFirstRender.current) {
      const lu = genLotUnits(selectedInstrument, calc);
      setLotUnits(lu);
      setTradeSizeInfo((tsi) => ({
        base: tsi?.base || "Lots",
        value: tsi?.value || (tsi?.base === "Units" ? Number(lu) : (tsi?.value || 1)),
        unitsOf1Lot: Number(lu),
      }));
      setTimeout(() => {
        isFirstRender.current = false;
      }, 500);
      previous.current.selectedInstrument = selectedInstrument;
      return;
    }
    if(selectedInstrument)
    {
      if(previous.current.selectedInstrument?.DisplaySymbolName === selectedInstrument?.DisplaySymbolName)
      {
        // lot units changed
        saveLotUnits(selectedInstrument, lotUnits.toString(), dispatch);
        setTradeSizeInfo((tsi) => ({
          base: tsi?.base || "Lots",
          value: tsi?.value || (tsi?.base === "Units" ? Number(lotUnits) : 1),
          unitsOf1Lot: Number(lotUnits),
        }));
      } else {
        // selected instrument changed
        const lu = genLotUnits(selectedInstrument);
        setLotUnits(lu);  
        setTradeSizeInfo((tsi) => ({
          base: tsi?.base || "Lots",
          value: tsi?.base === "Units" ? Number(lu) : 1,
          unitsOf1Lot: Number(lu),
        }));
      }
    }
    previous.current.selectedInstrument = selectedInstrument;
  }, [selectedInstrument, lotUnits]);

  const lotUnitsChanged: ChangeEventHandler<HTMLInputElement> = (e) => {
    const lu = onlyNum(e.target.value);
    if(selectedInstrument)
      saveLotUnits(selectedInstrument, lu, dispatch);
    setLotUnits(onlyNum(e.target.value));
  };

  return selectedInstrument ? (
    <div className={className || "col-12"}>
      <InputGroup
        type="text"
        hint={
          selectedInstrument.Market === "Crypto"
            ? languageData.this_may_vary_in_your_broker
            : ""
        }
        label={languageData.units_of_1_lot}
        value={lotUnits}
        onChange={lotUnitsChanged}
      />
    </div>
  ) : (
    <></>
  );
}

export default UnitsOf1Lot;
